import { parent } from '.';

export const setLoading = (value?: number) => {
  parent.postMessage({ playdeck: { method: 'loading', value: value } }, '*');
};
